/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AppAccessType = 'SHARED' | 'PERSONAL' | unhandledEnumCase;

export type AppPermissionInfo = {
  name: string;
  id: number;
  icon?: string;
  shortDescription: string;
  longDescription: string;
  isAllowed: boolean;
  isOnAppConfig: boolean;
  readOnly?: boolean;
  isOnInstalls: Default<boolean>;
};

export type EmaClientConfig = {
  clientId: string;
  issuerUrl: string;
  tenantId: number;
};

export type EntityType = 'TEAM' | 'USER' | unhandledEnumCase;

export type EntityTypeAndId = { entityType: EntityType; entityId: number };

export type InstallPermissionAccessState =
  | 'EVERYONE'
  | 'SUPER_ADMINS_AND_AUTHORIZED_INSTALLERS'
  | 'SPECIFIC_USERS_AND_TEAMS'
  | unhandledEnumCase;

export type InstalledInfo = {
  userId: number;
  email?: string;
  firstName?: string;
  lastName?: string;
};

export type ApplicationGovernanceError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ApprovableAppWithStatus = {
  approved: boolean;
  appId: number;
  appName: string;
  iconUrl?: string;
  hubSpotBuilt: boolean;
  appAccessType: Default<AppAccessType>;
};

export type ApproveAppGovernancePermissionsRequest = {
  appId: number;
  installPermissionAccessState: InstallPermissionAccessState;
  optionalAppPermissions: Default<number[]>;
  conditionallyRequiredAppPermissions: Default<number[]>;
  entityTypeAndIds: Default<EntityTypeAndId[]>;
};

export type ApproveAppGovernancePermissionsResponse = {
  appId: number;
  appName: string;
  iconUrl?: string;
  appAccessType: AppAccessType;
  installPermissionAccessState: InstallPermissionAccessState;
  requiredAppPermissions: Default<AppPermissionInfo[]>;
  conditionallyRequiredAppPermissions: Default<AppPermissionInfo[]>;
  optionalAppPermissions: Default<AppPermissionInfo[]>;
  installedInfos: Default<InstalledInfo[]>;
  entityTypeAndIds: Default<EntityTypeAndId[]>;
};

export type ApprovedApplicationsCursor = { offset: number };

export type CheckAppInstallabilityAppAuthRequest = {
  appId: number;
  conditionallyRequiredAppPermissionIds: Default<number[]>;
  optionalAppPermissionIds: Default<number[]>;
};

export type CheckAppInstallabilityResponse = {
  appId: number;
  appInstallabilityStatus: AppInstallabilityStatus;
  isAppApproved: boolean;
  isUserAllowed: boolean;
  optionalAppPermissionIdsLackingPermissions: Default<number[]>;
  conditionallyRequiredAppPermissionIdsLackingPermissions: Default<number[]>;
  isAppApprovable: Default<boolean>;
};

export type EnableApplicationInstallableRequest = { appId: number };

export type EnableApplicationInstallableResponse = {
  appId: number;
  lastModifiedAt: number;
};

export type GetAppDataPermissionsStatusRequest = { appId: number };

export type GetAppDataPermissionsStatusResponse = {
  hasDataPermissions: boolean;
};

export type GetAppEmaStatusRequest = { appId: number };

export type GetAppEmaStatusResponse = {
  emaOptedIn: boolean;
  trustedIssuerUrl?: string;
  emaClientConfigs: Default<EmaClientConfig[]>;
};

export type GetAppGovernancePermissionsRequest = { appId: number };

export type GetAppGovernancePermissionsResponse = {
  appId: number;
  appName: string;
  iconUrl?: string;
  appAccessType: AppAccessType;
  installPermissionAccessState: InstallPermissionAccessState;
  requiredAppPermissions: Default<AppPermissionInfo[]>;
  conditionallyRequiredAppPermissions: Default<AppPermissionInfo[]>;
  optionalAppPermissions: Default<AppPermissionInfo[]>;
  entityTypeAndIds: Default<EntityTypeAndId[]>;
  approvedAt: number;
  hasDataPermissions: Default<boolean>;
};

export type GetApplicationGovernanceRequest = { appId: number };

export type GetApplicationGovernanceResponse = {
  appId: number;
  portalWideStatus: GovernanceStatus;
};

export type GetApprovableAppsWithStatusRequest = {};

export type GetApprovableAppsWithStatusResponse = {
  approvableAppsWithStatus: Default<ApprovableAppWithStatus[]>;
};

export type GetApprovedApplicationForUser = {
  appId: number;
  appName: string;
  iconUrl?: string;
  appAccessType: AppAccessType;
  installPermissionAccessState: InstallPermissionAccessState;
  approvedAtTimestamp: number;
  installCount: number;
  installedInfo?: InstalledInfo;
  listingSlug?: string;
  isConnectorApp: Default<boolean>;
  buildPlatformTag?: BuildPlatformTag;
};

export type GetApprovedApplicationPagedRequest = {
  offset: Default<ApprovedApplicationsCursor>;
  pageLength: Default<number>;
};

export type GetApprovedApplicationPagedResponse = {
  total: number;
  results: Default<GetApprovedApplicationResponse[]>;
  hasMore: boolean;
  offset: ApprovedApplicationsCursor;
};

export type GetApprovedApplicationResponse = {
  appId: number;
  appName: string;
  iconUrl?: string;
  appAccessType: AppAccessType;
  installPermissionAccessState: InstallPermissionAccessState;
  approvedAtTimestamp: number;
  installCount: number;
  installedInfo?: InstalledInfo;
  listingSlug?: string;
  buildPlatformTag?: BuildPlatformTag;
};

export type GetApprovedApplicationsForUserPagedRequest = {
  offset: Default<ApprovedApplicationsCursor>;
  pageLength: Default<number>;
};

export type GetApprovedApplicationsForUserPagedResponse = {
  total: number;
  results: Default<GetApprovedApplicationForUser[]>;
  hasMore: boolean;
  offset: ApprovedApplicationsCursor;
};

export type GetAppsGovernanceStatusAppAuthRequest = {
  appIds: Default<number[]>;
};

export type GetAppsGovernanceStatusResponse = {
  appGovernanceStatuses: Default<Record<string, AppGovernanceStatus>>;
};

export type GetListingIdsToExcludeRequest = {};

export type GetListingIdsToExcludeResponse = { listingIds: Default<string[]> };

export type GetOrCreateConnectedAppObjectRequest = { appId: number };

export type GetOrCreateConnectedAppObjectResponse = {
  objectId: number;
  appId: number;
};

export type RemoveAppPermissionsFromInstallsRequest = {
  appId: number;
  appPermissionIds: Default<number[]>;
};

export type RemoveAppPermissionsFromInstallsResponse = {};

export type RevokeApprovalRequest = { appId: number };

export type RevokeApprovalResponse = { appId: number };

export type UpdateAllowedAppPermissionsRequest = {
  appId: number;
  conditionallyRequiredAppPermissions: Default<number[]>;
  optionalAppPermissions: Default<number[]>;
};

export type UpdateAllowedAppPermissionsResponse = {
  appId: number;
  requiredAppPermissions: Default<AppPermissionInfo[]>;
  conditionallyRequiredAppPermissions: Default<AppPermissionInfo[]>;
  optionalAppPermissions: Default<AppPermissionInfo[]>;
};

export type UpdateAllowedEntityTypeAndIdsRequest = {
  appId: number;
  installPermissionAccessState: InstallPermissionAccessState;
  entityTypeAndIds: Default<EntityTypeAndId[]>;
};

export type UpdateAllowedEntityTypeAndIdsResponse = {
  appId: number;
  installPermissionAccessState: InstallPermissionAccessState;
  entityTypeAndIds: Default<EntityTypeAndId[]>;
};

export type UpdateAppEmaStatusRequest = {
  appId: number;
  emaOptedIn: boolean;
  trustedIssuerUrl?: string;
};

export type UpdateAppEmaStatusResponse = {
  appId: number;
  emaOptedIn: boolean;
  trustedIssuerUrl?: string;
};

export type ErrorType =
  | 'ALREADY_ENABLED'
  | 'NOT_AUTHORIZED'
  | 'APPLICATION_NOT_INSTALLED'
  | 'APPLICATION_NOT_FOUND'
  | 'APPLICATION_UNGOVERNED'
  | 'INTERNAL_ERROR'
  | 'ILLEGAL_ARGUMENTS'
  | 'APP_NOT_APPROVED'
  | 'EMA_NOT_AVAILABLE'
  | 'SSO_NOT_CONFIGURED'
  | 'OAUTH_CLIENT_REVISION_NOT_FOUND'
  | unhandledEnumCase;

export type AppInstallabilityStatus =
  | 'INSTALLABLE'
  | 'NOT_INSTALLABLE'
  | unhandledEnumCase;

export type GovernanceStatus =
  | 'UNGOVERNED'
  | 'INSTALLABLE_BY_ALL_USERS'
  | 'INSTALLABLE_BY_SUPER_ADMINISTRATORS'
  | unhandledEnumCase;

export type AppGovernanceStatus = 'UNGOVERNED' | 'GOVERNED' | unhandledEnumCase;

export type BuildPlatformTag =
  | 'UNKNOWN'
  | 'BREEZE'
  | 'LOVABLE'
  | unhandledEnumCase;

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type GetApplicationGovernanceRequestType =
  Requestify<GetApplicationGovernanceRequest>;
export type GetApplicationGovernanceResponseType =
  GetApplicationGovernanceResponse;
export type GetApplicationGovernanceErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const getApplicationGovernanceRpc: ChirpAvroRpcDetails<
  GetApplicationGovernanceRequestType,
  GetApplicationGovernanceResponseType,
  GetApplicationGovernanceErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getApplicationGovernance',
  auth: 'app',
  fingerprint: '3xbWAJg_KgN-Z2xqjxPZpB27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type EnableApplicationInstallableRequestType =
  Requestify<EnableApplicationInstallableRequest>;
export type EnableApplicationInstallableResponseType =
  EnableApplicationInstallableResponse;
export type EnableApplicationInstallableErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const enableApplicationInstallableRpc: ChirpAvroRpcDetails<
  EnableApplicationInstallableRequestType,
  EnableApplicationInstallableResponseType,
  EnableApplicationInstallableErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'enableApplicationInstallable',
  auth: 'app',
  fingerprint: '9wyW9htCBhKgAXvxlhYS_x27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetApprovedApplicationPaginatedRequestType =
  Requestify<GetApprovedApplicationPagedRequest>;
export type GetApprovedApplicationPaginatedResponseType =
  GetApprovedApplicationPagedResponse;
export type GetApprovedApplicationPaginatedErrorType =
  ApplicationGovernanceError & HubspotMetadata;
export const getApprovedApplicationPaginatedRpc: ChirpAvroRpcDetails<
  GetApprovedApplicationPaginatedRequestType,
  GetApprovedApplicationPaginatedResponseType,
  GetApprovedApplicationPaginatedErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getApprovedApplicationPaginated',
  auth: 'app',
  fingerprint: 'B8aIGUXBuJ76zhf7uK9Yxx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RevokeApprovalRequestType = Requestify<RevokeApprovalRequest>;
export type RevokeApprovalResponseType = RevokeApprovalResponse;
export type RevokeApprovalErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const revokeApprovalRpc: ChirpAvroRpcDetails<
  RevokeApprovalRequestType,
  RevokeApprovalResponseType,
  RevokeApprovalErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'revokeApproval',
  auth: 'app',
  fingerprint: '7Rqz1UTuWIWbEYoqbLs8zR27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppGovernancePermissionsRequestType =
  Requestify<GetAppGovernancePermissionsRequest>;
export type GetAppGovernancePermissionsResponseType =
  GetAppGovernancePermissionsResponse;
export type GetAppGovernancePermissionsErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const getAppGovernancePermissionsRpc: ChirpAvroRpcDetails<
  GetAppGovernancePermissionsRequestType,
  GetAppGovernancePermissionsResponseType,
  GetAppGovernancePermissionsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getAppGovernancePermissions',
  auth: 'app',
  fingerprint: 'wFHKhHlUSwLiSpbebMZ3gh27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ApproveAppGovernancePermissionsRequestType =
  Requestify<ApproveAppGovernancePermissionsRequest>;
export type ApproveAppGovernancePermissionsResponseType =
  ApproveAppGovernancePermissionsResponse;
export type ApproveAppGovernancePermissionsErrorType =
  ApplicationGovernanceError & HubspotMetadata;
export const approveAppGovernancePermissionsRpc: ChirpAvroRpcDetails<
  ApproveAppGovernancePermissionsRequestType,
  ApproveAppGovernancePermissionsResponseType,
  ApproveAppGovernancePermissionsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'approveAppGovernancePermissions',
  auth: 'app',
  fingerprint: 'vuASiqtzY6txbGjZI_99ph27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateAllowedAppPermissionsRequestType =
  Requestify<UpdateAllowedAppPermissionsRequest>;
export type UpdateAllowedAppPermissionsResponseType =
  UpdateAllowedAppPermissionsResponse;
export type UpdateAllowedAppPermissionsErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const updateAllowedAppPermissionsRpc: ChirpAvroRpcDetails<
  UpdateAllowedAppPermissionsRequestType,
  UpdateAllowedAppPermissionsResponseType,
  UpdateAllowedAppPermissionsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'updateAllowedAppPermissions',
  auth: 'app',
  fingerprint: 'eO8AOUdsLSWoEc_IQm2VEx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateAllowedEntityTypeAndIdsRequestType =
  Requestify<UpdateAllowedEntityTypeAndIdsRequest>;
export type UpdateAllowedEntityTypeAndIdsResponseType =
  UpdateAllowedEntityTypeAndIdsResponse;
export type UpdateAllowedEntityTypeAndIdsErrorType =
  ApplicationGovernanceError & HubspotMetadata;
export const updateAllowedEntityTypeAndIdsRpc: ChirpAvroRpcDetails<
  UpdateAllowedEntityTypeAndIdsRequestType,
  UpdateAllowedEntityTypeAndIdsResponseType,
  UpdateAllowedEntityTypeAndIdsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'updateAllowedEntityTypeAndIds',
  auth: 'app',
  fingerprint: 'mv_lhhpfink35O1GBpf7dx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetApprovableAppsWithStatusRequestType =
  Requestify<GetApprovableAppsWithStatusRequest>;
export type GetApprovableAppsWithStatusResponseType =
  GetApprovableAppsWithStatusResponse;
export type GetApprovableAppsWithStatusErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const getApprovableAppsWithStatusRpc: ChirpAvroRpcDetails<
  GetApprovableAppsWithStatusRequestType,
  GetApprovableAppsWithStatusResponseType,
  GetApprovableAppsWithStatusErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getApprovableAppsWithStatus',
  auth: 'app',
  fingerprint: 'Bupb0O2ndZzT8PU-QtxGuB27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RemoveAppPermissionsFromInstallsRequestType =
  Requestify<RemoveAppPermissionsFromInstallsRequest>;
export type RemoveAppPermissionsFromInstallsResponseType =
  RemoveAppPermissionsFromInstallsResponse;
export type RemoveAppPermissionsFromInstallsErrorType =
  ApplicationGovernanceError & HubspotMetadata;
export const removeAppPermissionsFromInstallsRpc: ChirpAvroRpcDetails<
  RemoveAppPermissionsFromInstallsRequestType,
  RemoveAppPermissionsFromInstallsResponseType,
  RemoveAppPermissionsFromInstallsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'removeAppPermissionsFromInstalls',
  auth: 'app',
  fingerprint: '59stX4C8Kpg5UYCqgfD1vx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetOrCreateConnectedAppObjectRequestType =
  Requestify<GetOrCreateConnectedAppObjectRequest>;
export type GetOrCreateConnectedAppObjectResponseType =
  GetOrCreateConnectedAppObjectResponse;
export type GetOrCreateConnectedAppObjectErrorType =
  ApplicationGovernanceError & HubspotMetadata;
export const getOrCreateConnectedAppObjectRpc: ChirpAvroRpcDetails<
  GetOrCreateConnectedAppObjectRequestType,
  GetOrCreateConnectedAppObjectResponseType,
  GetOrCreateConnectedAppObjectErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getOrCreateConnectedAppObject',
  auth: 'app',
  fingerprint: 'r19Dca9_SQQn4XGE-rzJUx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppsGovernanceStatusRequestType =
  Requestify<GetAppsGovernanceStatusAppAuthRequest>;
export type GetAppsGovernanceStatusResponseType =
  GetAppsGovernanceStatusResponse;
export type GetAppsGovernanceStatusErrorType = EmptyError & HubspotMetadata;
export const getAppsGovernanceStatusRpc: ChirpAvroRpcDetails<
  GetAppsGovernanceStatusRequestType,
  GetAppsGovernanceStatusResponseType,
  GetAppsGovernanceStatusErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getAppsGovernanceStatus',
  auth: 'app',
  fingerprint: 'CGG4px4t4UgfPifa9l9hjpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetApprovedApplicationsForUserPagedRequestType =
  Requestify<GetApprovedApplicationsForUserPagedRequest>;
export type GetApprovedApplicationsForUserPagedResponseType =
  GetApprovedApplicationsForUserPagedResponse;
export type GetApprovedApplicationsForUserPagedErrorType =
  ApplicationGovernanceError & HubspotMetadata;
export const getApprovedApplicationsForUserPagedRpc: ChirpAvroRpcDetails<
  GetApprovedApplicationsForUserPagedRequestType,
  GetApprovedApplicationsForUserPagedResponseType,
  GetApprovedApplicationsForUserPagedErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getApprovedApplicationsForUserPaged',
  auth: 'app',
  fingerprint: 'ZXcVSBEcf2BsosZCV2VOzR27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetListingIdsToExcludeRequestType =
  Requestify<GetListingIdsToExcludeRequest>;
export type GetListingIdsToExcludeResponseType = GetListingIdsToExcludeResponse;
export type GetListingIdsToExcludeErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const getListingIdsToExcludeRpc: ChirpAvroRpcDetails<
  GetListingIdsToExcludeRequestType,
  GetListingIdsToExcludeResponseType,
  GetListingIdsToExcludeErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getListingIdsToExclude',
  auth: 'app',
  fingerprint: 'VSI7hmwko0WCfbiG4CSwgx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppDataPermissionsStatusRequestType =
  Requestify<GetAppDataPermissionsStatusRequest>;
export type GetAppDataPermissionsStatusResponseType =
  GetAppDataPermissionsStatusResponse;
export type GetAppDataPermissionsStatusErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const getAppDataPermissionsStatusRpc: ChirpAvroRpcDetails<
  GetAppDataPermissionsStatusRequestType,
  GetAppDataPermissionsStatusResponseType,
  GetAppDataPermissionsStatusErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getAppDataPermissionsStatus',
  auth: 'app',
  fingerprint: 'YmhNjFCZlq7qQ1hy2XMDTB27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CheckAppInstallabilityRequestType =
  Requestify<CheckAppInstallabilityAppAuthRequest>;
export type CheckAppInstallabilityResponseType = CheckAppInstallabilityResponse;
export type CheckAppInstallabilityErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const checkAppInstallabilityRpc: ChirpAvroRpcDetails<
  CheckAppInstallabilityRequestType,
  CheckAppInstallabilityResponseType,
  CheckAppInstallabilityErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'checkAppInstallability',
  auth: 'app',
  fingerprint: 'FMj91AsZ_RIcf-mJilLyVx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppEmaStatusRequestType = Requestify<GetAppEmaStatusRequest>;
export type GetAppEmaStatusResponseType = GetAppEmaStatusResponse;
export type GetAppEmaStatusErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const getAppEmaStatusRpc: ChirpAvroRpcDetails<
  GetAppEmaStatusRequestType,
  GetAppEmaStatusResponseType,
  GetAppEmaStatusErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'getAppEmaStatus',
  auth: 'app',
  fingerprint: 'DOWqptzedVQMwGDStJTnsR27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateAppEmaStatusRequestType =
  Requestify<UpdateAppEmaStatusRequest>;
export type UpdateAppEmaStatusResponseType = UpdateAppEmaStatusResponse;
export type UpdateAppEmaStatusErrorType = ApplicationGovernanceError &
  HubspotMetadata;
export const updateAppEmaStatusRpc: ChirpAvroRpcDetails<
  UpdateAppEmaStatusRequestType,
  UpdateAppEmaStatusResponseType,
  UpdateAppEmaStatusErrorType,
  false
> = {
  serviceName:
    'com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc',
  rpcName: 'updateAppEmaStatus',
  auth: 'app',
  fingerprint: 'U7nZxnB0taC3kUfHfP-gyx27o7DqupXp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
